import React, {FC, memo} from "react";
import {AccessoriesProps} from "./Accessories-types";
import {Body, Foot, Head, Root, Title} from "./Accessories-styles";
import AccessoriesList from "../AccessoriesList/AccessoriesList";
import AccessoriesSettings from "../AccessoriesSettings/AccessoriesSettings";
import {useRecoilValue} from "recoil";
import {stateMobileDrawerTabId, stateAccessoriesBlocks} from "../../data/atoms";
import {MobileGroupName} from "../../data";

const Accessories: FC<AccessoriesProps> = memo((props) => {
    const {onTypeSelect, onSelect} = props;

    const accessories = useRecoilValue(stateAccessoriesBlocks);

    const activeTab = useRecoilValue(stateMobileDrawerTabId);

    if (!accessories.length) {
        return null;
    }

    return (
        <Root $isVisibleOnMobile={activeTab === MobileGroupName.accessories}>
            <Head>
                <Title>Аксессуары</Title>
            </Head>

            <Body>
                <AccessoriesList accessories={accessories} onAccessoireSelect={onTypeSelect}/>
            </Body>

            <Foot>
                <AccessoriesSettings accessories={accessories} onOptionSelect={onSelect}/>
            </Foot>
        </Root>
    )
});

export default Accessories;
